module.exports = __webpack_public_path__ + "static/media/0013.c410e773.jpg";